/**
 * Converts a value to a number, returning `defaultValue` if conversion fails.
 * Note: falsy inputs (including `0`, `""`, `undefined`) always return `defaultValue`.
 * If you need to distinguish 0 from "not provided", use a different approach.
 */
export const parseNumber = (
  str: string | number | undefined,
  defaultValue: number
): number => {
  if (!str) {
    return defaultValue;
  }

  const asNumber = Number(str);
  return Number.isNaN(asNumber) ? defaultValue : asNumber;
};
